/**
 * Languages that we actually have translations for (SINGLE SOURCE OF TRUTH).
 *
 * Lives in `@splitfiesta/shared` rather than `@splitfiesta/i18n` so that
 * packages/core (consumed by apps/api, whose `moduleResolution: node` cannot
 * read package `exports` subpaths) can reach it. `@splitfiesta/i18n`
 * re-exports both symbols, so its public API is unchanged.
 */
export const ACTUALLY_SUPPORTED_LANGUAGES = [
  'en',
  'fr',
  'es',
  'de',
  'pt',
] as const;

export type ActuallySupportedLanguage =
  (typeof ACTUALLY_SUPPORTED_LANGUAGES)[number];
